import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({
  title = "Siridharini - Sustainable Agricultural Investment",
  description = "Invest in premium sustainable agricultural projects with Siridharini. Sandalwood, teak wood, and organic farming opportunities near Bangalore. Money Does Grow On Trees.",
  keywords = "agricultural investment, sandalwood investment, teak wood farming, sustainable agriculture, managed farmland Bangalore, agricultural returns, organic farming, farm investment India",
  url = "https://siridharini.in",
  image = "/logo192.png",
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Siridharini" />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Siridharini" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="theme-color" content="#2d5016" />
      <meta name="msapplication-TileColor" content="#2d5016" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Siridharini",
          "url": "https://siridharini.in",
          "logo": "https://siridharini.in/logo192.png",
          "description": "Premium sustainable agricultural investment opportunities with sandalwood, teak and organic farming",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-9448472706",
            "contactType": "Customer Service",
            "email": "connect@siridharini.com"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Rashtriya Vidyalaya Road, 2nd Block, Jaya Nagar East",
            "addressLocality": "Jayanagar",
            "addressRegion": "Karnataka",
            "addressCountry": "India",
            "postalCode": "560011"
          },
          "sameAs": [
            "https://www.facebook.com/siridharini",
            "https://www.instagram.com/siridharini",
            "https://www.linkedin.com/company/siridharini"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEOHelmet;